import React, { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { useAppDispatch, useAppSelector } from '../../../lib/redux/hooks';
import { CustomAccordion } from "../../../ui/molecules/accordion";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import TextArea from "../../../ui/molecules/textArea/TextArea";
import { ErrorPopup } from "../../../ui/organisms/errorPopup";
import { SuccessPopup } from "../../../ui/organisms/successPopup";
import { getContactById, setContactCreateRequestField, setContactCreateStatus, setContactUpdateRequest, setContactUpdateRequestField, setContactUpdateStatus } from "../feature/contact/slice";
import '../style.scss';


export function BoxRubricaEdit() {
    const dispatch = useAppDispatch()

    const [expanded, setExpanded] = React.useState<string | false>("panel1");
    const [mode, setMode] = React.useState<"create" | "update">("create")

    const handleToggleAccordion = (panel: string) => {
        setExpanded(expanded === panel ? false : panel);
    };

    const customerState = useAppSelector(state => state.customer)
    const contactState = useAppSelector(state => state.contact)

    useEffect(() => {
        if (customerState.getCustomerByIdStatus === "successfully" && customerState.getCustomerByIdResponse !== undefined) {
            dispatch(setContactCreateRequestField({ field: "customerId", value: customerState.getCustomerByIdResponse.id }))
            if (customerState.getCustomerByIdResponse.contactId) {
                dispatch(getContactById(customerState.getCustomerByIdResponse.contactId))
            }
        }
    }, [customerState.getCustomerByIdStatus]);

    useEffect(() => {
        if (contactState.getContactByIdStatus === "successfully" && contactState.getContactByIdResponse !== undefined) {
            setMode("update")
            dispatch(setContactUpdateRequest(contactState.getContactByIdResponse))
        }
    }, [contactState.getContactByIdStatus]);

    const contactRequest = mode === "create" ? contactState.contactCreateRequest : contactState.contactUpdateRequest

    return (
        <div className="p-6 flex flex-col gap-6">
            {
                (contactState.contactCreateStatus === 'successfully' || contactState.contactUpdateStatus === 'successfully') ?
                    <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                        <SuccessPopup
                            active={contactState.contactCreateStatus === 'successfully' || contactState.contactUpdateStatus === 'successfully'}
                            message="Dati salvati correttamente."
                            onClose={() => {
                                dispatch(setContactCreateStatus("idle"))
                                dispatch(setContactUpdateStatus("idle"))
                            }}
                        />
                    </div> : (contactState.contactUpdateStatus === 'failed' || contactState.contactCreateStatus === 'failed') ?
                        <div className="px-6 pt-3 pb-1 flex flex-col gap-2">
                            <ErrorPopup
                                active={contactState.contactUpdateStatus === 'failed' || contactState.contactCreateStatus === 'failed'}
                                message="Si è verificato un errore durante il salvataggio dei dati."
                                onClose={() => {
                                    dispatch(setContactCreateStatus("idle"))
                                    dispatch(setContactUpdateStatus("idle"))
                                }}
                            />
                        </div> : null
            }
            <CustomAccordion
                id="panel1"
                title={<span className="text-uppercase text-white label-input">Contatti</span>}
                expanded={expanded === 'panel1'}
                onChange={() => handleToggleAccordion('panel1')}
                detailsClassName="flex flex-col gap-4"
            >
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        required
                        value={contactRequest.phone}
                        label={'Telefono'}
                        placeholder="Telefono"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "phone", value: text }))
                            } else
                                dispatch(setContactUpdateRequestField({ field: "phone", value: text }))
                        }}
                        error={!!contactState.contactCreateErrors.phone}
                        supportingText={contactState.contactCreateErrors.phone}
                    />
                    <MadfarmInput
                        required
                        value={contactRequest.officePhone}
                        label={'Telefono Ufficio'}
                        placeholder="Telefono Ufficio"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "officePhone", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "officePhone", value: text }))
                            }
                        }}
                        error={!!contactState.contactCreateErrors.officePhone}
                        supportingText={contactState.contactCreateErrors.officePhone}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        required
                        value={contactRequest.mobilePhone}
                        label={'Cellulare'}
                        placeholder="Cellulare"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "mobilePhone", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "mobilePhone", value: text }))
                            }
                        }}
                        error={!!contactState.contactCreateErrors.mobilePhone}
                        supportingText={contactState.contactCreateErrors.mobilePhone}
                    />
                    <MadfarmInput
                        value={contactRequest.fax}
                        label={'Fax'}
                        placeholder="Fax"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "fax", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "fax", value: text }))
                            }
                        }}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        defaultValue={contactRequest.email}
                        label={'Email'}
                        placeholder="Email"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "email", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "email", value: text }))
                            }
                        }}
                    />
                    <MadfarmInput
                        value={contactRequest.personalEmail}
                        label={'Email Personale'}
                        placeholder="Email Personale"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "personalEmail", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "personalEmail", value: text }))
                            }
                        }}
                    />
                </div>
                <div className='grid grid-cols-2 gap-4'>
                    <MadfarmInput
                        value={contactRequest.pec}
                        label={'PEC'}
                        placeholder="PEC"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "pec", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "pec", value: text }))
                            }
                        }}
                    />
                    <MadfarmInput
                        value={contactRequest.otherEmail}
                        label={'Altra Email'}
                        placeholder="Altra Email"
                        onChangeText={(text) => {
                            if (mode === "create") {
                                dispatch(setContactCreateRequestField({ field: "otherEmail", value: text }))
                            } else {
                                dispatch(setContactUpdateRequestField({ field: "otherEmail", value: text }))
                            }
                        }}
                    />
                </div>
            </CustomAccordion>
            <CustomAccordion
                id="panel2"
                title={<span className="text-uppercase text-white label-input">Note</span>}
                expanded={expanded === 'panel2'}
                onChange={() => handleToggleAccordion('panel2')}
            >
                <TextArea
                    label="Note"
                    value={contactRequest.note}
                    onChangeText={(text) => {
                        if (mode === "create") {
                            dispatch(setContactCreateRequestField({ field: "note", value: text }))
                        } else {
                            dispatch(setContactUpdateRequestField({ field: "note", value: text }))
                        }
                    }}
                />
            </CustomAccordion>
        </div>
    )
}